var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6152 13.9495C25.6152 17.7272 23.7195 21.3906 21.4687 23.8665C19.2179 26.3424 15.8875 27 12.4532 27C9.01893 27 5.56731 26.4739 3.3182 23.998C1.0691 21.5221 0 17.7253 0 13.9495C0 10.1737 1.27357 6.59988 3.5244 4.12587C5.77524 1.65186 9.02067 1 12.4532 1C15.8858 1 19.4345 1.31831 21.6853 3.79232C23.9361 6.26633 25.6152 10.1718 25.6152 13.9495Z",
    fill: "#2E30E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64557 12.3659L9.85801 10.6357L14.2576 11.1759L13.4443 17.8L16.1301 18.1298L15.9157 19.8764L8.41827 18.9559L8.63273 17.2092L11.3186 17.539L11.9195 12.6451L9.64557 12.3659ZM12.1828 9.68344L12.4559 7.45893L14.7793 7.74421L14.5062 9.96871L12.1828 9.68344Z",
    fill: "#FAFF29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2c7d53eb285c260cf2addd09f6f6f166.svg";
export { ForwardRef as ReactComponent };